import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ApiHttpClient } from 'app/http/clients/api';
import { environment } from 'environments/environment';
import { Contact } from 'app/models/dto/contact.model';
import { DocusignEnvelope } from 'app/models/dto/docusign-envelope.model';

@Injectable()
export class OwnerApplicationService {

  protected baseUrl: string;

  constructor(protected http: ApiHttpClient) {
    this.baseUrl = environment.API_URL;
  }

  generateAndSend(contactId: number): Observable<Contact> {
    return this.ownerAppRequest(contactId, 'post');
  }

  update(contactId: number): Observable<Contact> {
    return this.ownerAppRequest(contactId, 'put');
  }

  delete(contactId: number): Observable<null> {
    return this.ownerAppRequest(contactId, 'delete');
  }

  getMostRecentEnvelope(contact) {
    if (contact && contact.envelopes && contact.envelopes.length > 0) {
      const envelope = contact.envelopes
        .filter((env: DocusignEnvelope) => env.type === 'ownerApplication')
        .sort(this.sortEnvelopes)
        .pop();
      return envelope;
    }
    return undefined;
  }

  sortEnvelopes(a, b) {
    const da = new Date(a.created).getTime();
    const db = new Date(b.created).getTime();
    return da < db ? -1 : da > db ? 1 : 0;
  }

  protected ownerAppRequest(contactId, requestMethod: string): Observable<any> {
    return this.http[requestMethod](this.ownerApplicationUrl(contactId));
  }

  protected ownerApplicationUrl(contactId: number) {
    return `${this.baseUrl}/contact/${contactId}/owner-application`;
  }
}
